import { ReactComponent as BreadcrumbChevron } from '../../assets/icons/BreadcrumbChevron.svg';
import { BreadcrumbLink, BreadcrumbsStyled, BreadcrumbText } from './styles';
import { UPBreadcrumbsProps } from './types';

const UPBreadcrumbs = (props: UPBreadcrumbsProps): JSX.Element => {
  const { items, testId } = props;

  return (
    <BreadcrumbsStyled aria-label="breadcrumb" separator={<BreadcrumbChevron />} data-testid={testId}>
      {items.map((item, index) => {
        const isCurrent = index === items.length - 1;

        if (item.route && !isCurrent) {
          return (
            <BreadcrumbLink key={item.key} to={item.route} title={item.label}>
              {item.label}
            </BreadcrumbLink>
          );
        }

        return (
          <BreadcrumbText
            key={item.key}
            isCurrent={isCurrent}
            title={item.label}
            aria-current={isCurrent ? 'page' : undefined}
          >
            {item.label}
          </BreadcrumbText>
        );
      })}
    </BreadcrumbsStyled>
  );
};

UPBreadcrumbs.defaultProps = {
  testId: undefined,
};

export default UPBreadcrumbs;
